import formatAmount from '../worklets/formatAmount';
const useFormatPriceChangeForPortfolioWorklet = (priceChangeShared) => {
    const formatPriceChangeForPortfolio = (profitLossPct, profitLoss) => {
        'worklet';
        if (profitLossPct !== null && profitLossPct !== undefined && profitLoss !== null && profitLoss !== undefined) {
            return `${Math.abs(Number(profitLossPct)).toFixed(2)}% (${formatAmount(Math.abs(Number(profitLoss)), '£')})`;
        }
        return priceChangeShared.value;
    };
    return formatPriceChangeForPortfolio;
};
export default useFormatPriceChangeForPortfolioWorklet;
